const defaultState = {
  cart: [],
  fetchCart: [],
  cartResponseMessage: undefined,
  totalQuantity: undefined,
};

export default (state = defaultState, action) => {
  switch(action.type){
    case 'SET_CART_DETAILS':
      return {
        ...state,
        cart: action.cart,
      }
    case 'SET_FETCH_CART':
      return {
        ...state,
        fetchCart: action.fetchCart,
      }
    case 'SET_CART_MESSAGE':
      return {
        ...state,
        cartResponseMessage: action.cartResponseMessage,
      }
    case 'SET_TOTAL_QUANTITY':
      return {
        ...state,
        totalQuantity: action.totalQuantity,
      }
    default:
      return state;
  };
};
